export const REPORT_SESSION_ID_KEY = 'report_session_id'
